import { theme } from '@provi/provi-components'
import styled from 'styled-components'

export const SmallText = styled.small`
  color: ${theme.colors.blue900};
`
